export function ocrCard(str) {
    // let str = '中国农业银行信用卡贷后管理系统AORICULTURAL BANK OF CHINA改业务查询业务管理专项分期风险管理核销管理报表统计系统管理下载专区上传专区收单管理数据最新日期：2021002账户资料信息常用操作客户等级：预留姓名：陈兴风产品代码：CCGH2I客户资料查询交明查询币种：01人民币产品名称：农行贷记卡-金QQ联名IC农行贷记卡各岗位业务报表主卡卡号：6259960100521160客户层账号：44572101690001046主账户账号：44572101660001659卡片有效期：20231208操员44004452周洪中账户建立日期：20131201争议金额：0.0044H563账户总余额：10097.58总利息：1251.17所行部广东省茂名市化账户总本金：8364.99总超限费：0.00支行岗位业务主管岗总违约金（含纳金）：481.42账户锁定码：N业务人员岗风险管理岗总手续费：0.00客户级锁定码：永久额度总授信值：0.00临时额度总授信值：20000.00固定账单日：07临时额度终止日期：20180411账户级已使用总额度：10097.58账户级取现已使用总额度0.00额度内分期有效账户个数：专项分期有效账户个数：0账户归属网点：445732广东省茂名市化州橘洲支行核算归属行：445732主附卡标志：主卡附卡张数：1客户级CD值：9客户下卡片数：3一般账户本金：8364.99度内分期账户本金：0.00专项分期账户本金：0.00返回账户资料信息下载一般账户信息额度内分期信息专项分期信息客户贷料信息最近半年交易明您客户历史卡片信息客户名下其他账户信息历史值收记录客户风险信息查询'
    var card = /(主卡卡号)[^\x00-\xff]{0,}([0-9]*)/
    var lx = /(总利息)[^\x00-\xff]{1,}([0-9]+(\.){0,1}[0-9]*)/
    var zbj = /(账户总本金)[^\x00-\xff]{1,}([0-9]+(\.){0,1}[0-9]*)/
    var sxf = /(手续费)[^\x00-\xff]{1,}([0-9]+(\.){0,1}[0-9]*)/
    var wyj = /(违约金)[^\x00-\xff]{1,}([0-9]+(\.){0,1}[0-9]*)/
    var zh = /(主账户账号)[^\x00-\xff]{0,}([0-9]*)/
    var cpmc = /(产品名称)[^\x00-\xff]{0,1}([\u4e00-\u9fa5]*.*)/
    let res = {
        cardNumber: str.match(card)[2],
        principal: str.match(zbj)[2],
        interest: str.match(lx)[2],
        serviceCharge: str.match(sxf)[2],
        liquidatedDamages: str.match(wyj)[2],
        accountNumber: str.match(zh)[2],
    }
    return res

}
export function ocrJudgeBook() {
    let str = '原告：中国建设银行股份有限公司茂名市分行。住所地：茂名市茂名大道鲤鱼岭8号大院3号1-11层。统一社会信用代码：91440902617819569P。负责人：王勇，职务：行长。被告：柯海清，女，汉族，1985年9月23日出生。公民身份号码：440902198509234847。户籍地址：广东省茂名市茂南区新坡镇合水果子园村一组14号。其他联系地址：广东省茂名市茂南区计星路118号亿城名苑6栋17梯202房。联系电话：13500079941。诉讼请求：1.判令被告立即清偿其在原告处申请的粤通卡龙卡信用卡（卡号：6259651815803338）欠款本金24975.84元（消费本金233.85元；分期本金24741.99元)及其利息（含复利）946.92元[暂计至2022年5月19日，2022年5月20日起的利息按日利率万分之五计算至信用卡欠款付清之日，并按月计收复利]、违约金882.76元[按最低还款额未还部分的5%收取，计至2022年4月11日，此后不再产生]、账单分期手续费2282.88元。2.判令被告支付律师费2870.1元给原告。';
    var yg = /(原告)[^\x00-\xff]{0,1}([\u4e00-\u9fa5]*)/
    console.log(str.match(yg), '起诉状')
}

export function ocrFinancialDetail(str) {
    var num = /(贷款合约号：)[^\x00-\xff]{0,}([0-9]*)/
    var startDate = /(开始日期：)[^\x00-\xff]{0,}([0-9]*)/
    var endDate = /(到期日期：)[^\x00-\xff]{0,}([0-9]*)/
    var amount = /(贷款本金)[^\x00-\xff]{1,}([0-9]+(\.){0,1}[0-9]*)/
    var principal = /(还本总金额)[^\x00-\xff]{1,}([0-9]+(\.){0,1}[0-9]*)/
    var interest = /(还息总金额)[^\x00-\xff]{1,}([0-9]+(\.){0,1}[0-9]*)/
    console.log(str.match(num))
    console.log(str.match(startDate))
    console.log(str.match(endDate))
    console.log(str.match(amount))
    console.log(str.match(principal))
    console.log(str.match(interest))
    let data1
    if(str.match(startDate)[2] != null){
        if(str.match(startDate).length > 2){
            data1 = str.match(startDate)[2];
            data1 = data1.length == 8 ? data1.substring(0, 4) + '-' + data1.substring(4, 6) + '-' + data1.substring(6, 8) : ''
        }
        
    }
    

    let data2
    if(str.match(endDate) != null){
        if(str.match(endDate).length > 2){
            data2 = str.match(endDate)[2];
            data2 = data2.length == 8 ? data2.substring(0, 4) + '-' + data2.substring(4, 6) + '-' + data2.substring(6, 8) : ''
        }
        
    }
    let contractCodeStr
    if(str.match(num) != null){
        if(str.match(num).length > 2){
            contractCodeStr = str.match(num)[2]
        }
    }

    let amountStr
    if(str.match(amount) != null){
        if(str.match(amount).length > 2){
            amountStr = str.match(amount)[2]
        }
    }

    let principalStr
    if(str.match(principal) != null){
        if(str.match(principal).length > 2){
            principalStr = str.match(principal)[2]
        }
    }

    let interestStr
    if(str.match(interest) != null){
        if(str.match(interest).length > 2){
            interestStr = str.match(interest)[2]
        }
    }

    let res = {
        contractCode: contractCodeStr,
        borrowDate: data1,
        expiryDate: data2,
        amount: amountStr,
        principal: principalStr,
        interest: interestStr,
    }
    return res

}